<template>
  <v-card>
    <v-card-title class="display-2">
      {{ $t("title.create_subscription") }}
    </v-card-title>

    <v-card-text>
      <v-form
        spellcheck="false"
        ref="new_subscription_form"
        v-model="formValid"
        @submit.prevent="onSubmit"
      >
        <v-row>
          <v-col>
            <LicensePlateField
              ref="license_plate_field"
              v-model="form.license_plate"
              required
              @valid="valid => (licensePlateValid = valid)"
              @validating="
                validating => (validatingLicensePlateLoader = validating)
              "
              @clear-error="$emit('clear-error')"
            />
            <AvailableSubscriptionsSelect
              v-model="form.subscription_uuid"
              required
              class="mt-3"
            />
            <DatePickerMenu
              v-model="form.subscription_start_date"
              :label="$t('label.start_date')"
              class="mt-3"
              disabled
            />
          </v-col>
        </v-row>

        <v-card-actions class="px-0">
          <v-btn text color="grey" :disabled="loading" @click="$emit('cancel')">
            {{ $t("button.cancel") }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!canSave"
          >
            {{ $t("button.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { subscription_create } from "@/mixins/subscription";
import LicensePlateField from "@/components/fields/LicensePlateField.vue";
import AvailableSubscriptionsSelect from "@/components/fields/AvailableSubscriptionsSelect.vue";
import DatePickerMenu from "@/components/fields/DatePickerMenu.vue";

export default {
  name: "CreateSubscription",
  mixins: [subscription_create],
  components: {
    DatePickerMenu,
    AvailableSubscriptionsSelect,
    LicensePlateField
  },
  data() {
    return {
      form: {
        license_plate: { license_plate: "", license_plate_country_code: "NLD" },
        subscription_uuid: null,
        subscription_start_date: new Date()
      },
      formValid: false,
      licensePlateValid: false,
      validatingLicensePlateLoader: false,
      submitting: false
    };
  },
  computed: {
    loading() {
      return this.validatingLicensePlateLoader || this.submitting;
    },
    canSave() {
      if (!this.formValid) return false;
      if (this.loading || this.validatingLicensePlateLoader) return false;
      if (!this.licensePlateValid) return false;
      return true;
    }
  },
  methods: {
    resetForm() {
      this.form = {
        license_plate: { license_plate: "", license_plate_country_code: "NLD" },
        subscription_uuid: null,
        subscription_start_date: new Date()
      };
      this.formValid = false;
      this.licensePlateValid = false;
      this.validatingLicensePlateLoader = false;
      this.submitting = false;
      this.$refs.new_subscription_form.resetValidation();
      this.$refs.license_plate_field.reset();
    },
    onSubmit() {
      if (!this.$refs.new_subscription_form.validate() || !this.canSave) return;
      this.submitting = true;
      this.$store
        .dispatch("subscription/postSubscription", {
          ...this.form,
          license_plate: this.form.license_plate.license_plate,
          license_plate_country_code: this.form.license_plate
            .license_plate_country_code
        })
        .then(() => {
          this.$emit("submit");
          this.resetForm();
        })
        .catch(error => {
          this.$emit("error", error);
          this.$store.commit("viewstate/notify", {
            text: this.$t("error.subscription_create_failed"),
            color: "error"
          });
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>
